/**
 * lucide-mono — a quieter monochrome variant. Same Lucide icons, all rendered
 * in a single muted tone. Useful when colored extensions feel busy in dense
 * trees or when matching a more uniform editor aesthetic.
 */
import {
  File,
  FileCode,
  FileImage,
  FileJson,
  FileText,
  FileType,
  Folder,
  FolderOpen,
} from 'lucide-react';
import type { IconPack } from './types';

const TONE = 'w-4 h-4 text-base-content/60';

export const lucideMono: IconPack = {
  id: 'lucide-mono',
  name: 'Mono',
  description: 'Single-tone Lucide icons — quieter visual rhythm in dense trees.',

  getFileIcon(fileName) {
    const ext = fileName.split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'ts':
      case 'tsx':
      case 'js':
      case 'jsx':
        return <FileCode className={TONE} />;
      case 'json':
        return <FileJson className={TONE} />;
      case 'md':
      case 'txt':
        return <FileText className={TONE} />;
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'svg':
        return <FileImage className={TONE} />;
      case 'html':
      case 'css':
        return <FileType className={TONE} />;
      default:
        return <File className={TONE} />;
    }
  },

  getFolderIcon(_folderName, open) {
    return open
      ? <FolderOpen className={TONE} />
      : <Folder className={TONE} />;
  },
};
